
import { ActionType } from './ActionType.enum';
import { RoutingPositionStatus } from './RoutingPositionStatus.enum';

export class Issue {
    dateString: string;
    typeDictionartyKey: string;
    delay: number;
    text: string;

    constructor(issue: Issue) {
        if (issue != null) {
            this.dateString = issue.dateString;
            this.typeDictionartyKey = issue.typeDictionartyKey;
            this.delay = issue.delay;
            this.text = issue.text;
        }
    }
}


export class RoutingLog {
    hashKey: string;
    timestamp: string;
    activityType: string;
    note: string;
    executionType: string;

    constructor(log: RoutingLog) {
        if (log != null) {
            this.hashKey = log.hashKey;
            this.timestamp = log.timestamp;
            this.activityType = log.activityType;
            this.note = log.note;
            this.executionType = log.executionType;
        }
    }
}


export class LogEntryView {
    hashKey: string;
    timestamp: string;
    logActivityType: string;
    logActivityTypeTranslated: string;
    text: string;
    executionType: string;
    typeDictionartyKey: string;
    delay: number;

    constructor(log: Partial<LogEntryView>) {
        if (log != null) {
            this.hashKey = log.hashKey;
            this.timestamp = log.timestamp;
            this.logActivityType = log.logActivityType;
            this.text = log.text;
            this.executionType = log.executionType;
            this.typeDictionartyKey = log.typeDictionartyKey;
            this.delay = log.delay;
        }
    }

    public static createFromRoutingLog(log: RoutingLog) {
        return new LogEntryView({
            hashKey: log.hashKey,
            timestamp: log.timestamp,
            logActivityType: log.activityType,
            text: log.note,
            executionType: log.executionType,
            typeDictionartyKey: null,
            delay: null
        });
    }

    public static createFromIssue(issue: Issue) {
        return new LogEntryView({
            hashKey: null,
            timestamp: issue.dateString,
            logActivityType: null,
            text: issue.text,
            executionType: null,
            typeDictionartyKey: issue.typeDictionartyKey,
            delay: issue.delay
        });
    }
}

export class RoutingPositionLog {
    stationName: string;
    cargo: string;
    actionType: ActionType;
    positionStatus: RoutingPositionStatus;
    routingLogs = new Array<RoutingLog>();
    issues = new Array<Issue>();

    LogEntryViews = new Array<LogEntryView>();
    rowspan = 1;

    constructor(log: RoutingPositionLog) {
        if (log != null) {
            this.stationName = log.stationName;
            this.cargo = log.cargo;
            this.actionType = log.actionType;
            this.positionStatus = log.positionStatus;
            if (log.issues != null) {
                for (const i of log.issues) {
                    const issue = new Issue(i);
                    this.issues.push(issue);
                    this.LogEntryViews.push(LogEntryView.createFromIssue(issue));
                }
            }
            if (log.routingLogs != null) {
                for (const rl of log.routingLogs) {
                    const routingLog = new RoutingLog(rl);
                    this.routingLogs.push(routingLog);
                    this.LogEntryViews.push(LogEntryView.createFromRoutingLog(routingLog));
                }
            }
            // Zum Rendern muss mindestens eine Zeile existieren, auch wenn diese leer ist
            if (this.LogEntryViews.length === 0) {
                this.LogEntryViews.push(new LogEntryView({}));
            }
            this.rowspan = this.LogEntryViews.length;
        }
    }
}
